const PresentationWrapper = props => <div className="presentationWrapper">{props.children}</div>;
PresentationWrapper.propTypes = {};
export default PresentationWrapper;
